module.exports = __webpack_public_path__ + "img/arrow_white_2.7a46296b.svg";